<template>
  <b-modal
    id="faq-modal"
    scrollable
    hide-footer
    size="lg"
  >
    <template v-slot:modal-title>
      <span :style="style">
        {{ title }}
      </span>
    </template>

    <TTReader
      :config-path="[FAQ_CONFIG_KEY, 'text']"
      :panel="INFO_FAQ"
    />
  </b-modal>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import TTReader from '@/components/TipTap/wrappers/TTReader.vue'

import { StoryKeys } from '@/types'
import { FAQ_CONFIG_KEY } from '@/constants'

const components = {
  TTReader,
}

@Component({ components })
export default class FaqModal extends Vue {
  INFO_FAQ = StoryKeys.INFO_FAQ
  FAQ_CONFIG_KEY = FAQ_CONFIG_KEY

  get appLoaded () {
    return this.$typedStore.activeVisualisation.visualisationStore.app.appLoaded
  }

  get title () {
    return this.$typedStore.activeVisualisation.visualisationStore.app.config?.faq.title
  }

  get storySettingsPanel () {
    return this.$typedStore.activeVisualisation.visualisationStore.app.config.storySettings?.faq
  }

  get headingColor () {
    return this.storySettingsPanel?.headingColor || this.storySettingsPanel?.fontColor
  }

  get style () {
    return this.appLoaded ? {
      'font-family': this.storySettingsPanel?.fontFamily,
      color: this.headingColor,
    } : {}
  }
}

</script>
